import { render, staticRenderFns } from "./Take_quiz.vue?vue&type=template&id=2f86829f&scoped=true"
import script from "./Take_quiz.vue?vue&type=script&lang=js"
export * from "./Take_quiz.vue?vue&type=script&lang=js"
import style0 from "./Take_quiz.vue?vue&type=style&index=0&id=2f86829f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f86829f",
  null
  
)

export default component.exports